import { useUnit } from 'effector-react';
import $$giftTrustPage from 'models/pages/gift-trust';
import { Spinner } from 'react-bootstrap';

import useResources from 'hooks/useResources';

import { type GiftTrustItem } from 'types/zod/gift-trust-item';
import { type QuestionnaireInstance } from 'types/zod/questionnaire-instance';

type GiftItemGenerateButtonProps = {
    qInstanceId: QuestionnaireInstance['questionnaire_instance_id'];
    giftTrustItemId: GiftTrustItem['id'];
};

const GiftItemGenerateButton = (props: GiftItemGenerateButtonProps) => {
    const { qInstanceId, giftTrustItemId } = props;

    const { t } = useResources();

    const { jobs, giftTrustItems } = useUnit($$giftTrustPage.$tabs.map((tabs) => tabs[qInstanceId]));
    const job = jobs.find((job) => job.giftTrustItemId === giftTrustItemId);
    const isJobPending = !!job;
    const item = giftTrustItems.find((item) => item.id === giftTrustItemId);
    const isGenerated = item?.documentId;

    if (isGenerated) {
        return (
            <u>
                <strong>{t('giftTrustPage.table.columns.withdrawLetter.generatedLabel')}</strong>
            </u>
        );
    }

    return (
        <button
            className="btn btn-secondary ignore-row-click"
            type="button"
            onClick={() => $$giftTrustPage.generateGiftButtonClicked({ qInstanceId, giftTrustItemId })}
            disabled={isJobPending}
        >
            {isJobPending ? (
                <Spinner animation="border" size="sm" />
            ) : (
                (t('giftTrustPage.table.columns.withdrawLetter.generateButton') as string)
            )}
        </button>
    );
};

export default GiftItemGenerateButton;
